/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface SignageReadyInterface {
    /**
     * ...
     */
    sendSignageReadySignal(): Promise<void>;
}

export function supportsSignageReady(platform: unknown): platform is SignageReadyInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PlatformMessage.SignageReady);
    }
    return platform instanceof Object && 'sendSignageReadySignal' in platform;
}
